import { useEffect, useRef } from "react";
import { DRAWS } from "@/components/demos/draws";
import { useCanvasLoop } from "@/components/demos/canvasKit";

const Procedural = ({ k, time, title }) => {
  const ref = useCanvasLoop(DRAWS[k], time);
  return <canvas ref={ref} role="img" aria-label={title} className="absolute inset-0 h-full w-full" />;
};

const Video = ({ media, paused, className }) => {
  const ref = useRef(null);
  useEffect(() => {
    if (paused) ref.current?.pause();
    else ref.current?.play().catch(() => {});
  }, [paused]);
  return <video ref={ref} className={className} src={media.src} poster={media.poster || undefined} muted loop playsInline />;
};

export const DemoMedia = ({ media, title, time, paused }) => {
  const cls = "absolute inset-0 h-full w-full object-cover";
  if (media?.type === "video" && media.src) {
    return <Video className={cls} media={media} paused={paused} />;
  }
  if (media?.type === "image" && media.src) return <img className={cls} src={media.src} alt={title} />;
  if (media?.type === "embed" && media.src) {
    return <iframe className="absolute inset-0 h-full w-full border-0" src={media.src} title={title} allow="autoplay; fullscreen; picture-in-picture" />;
  }
  if (DRAWS[media?.key]) return <Procedural k={media.key} time={time} title={title} />;
  return null;
};

export const DemoCredit = ({ demo }) => (
  <div className="flex flex-col gap-2 sm:flex-row sm:justify-between" data-testid="demo-credit">
    <span className="eyebrow text-fg-2">{demo?.credit?.kind === "x1025" ? "x1025 footage" : "x1025 concept · In development"}</span>
    {demo?.note && <p className="text-[13px] text-fg-3">{demo.note}</p>}
  </div>
);
